import COMMON_ROUTES from '@/presentation/constants/routes/common.constant.js';
import { authRoutes } from '@/presentation/modules/auth';
import { categoryRoutes } from '@/presentation/modules/category';
import { dashboardRoutes } from '@/presentation/modules/dashboard';
import { settingRoutes } from '@/presentation/modules/setting';
import { requestRoutes } from '@/presentation/modules/request';
import { profileRoutes } from '@/presentation/modules/profile';

const commonRoutes = Object.freeze([
	{
		name: COMMON_ROUTES.root.name,
		path: COMMON_ROUTES.root.path,
		redirect: COMMON_ROUTES.root.redirect,
		children: [
			{
				name: COMMON_ROUTES.home.name,
				path: COMMON_ROUTES.home.path,
				component: COMMON_ROUTES.home.component,
			},
			{
				name: COMMON_ROUTES.payment.name,
				path: COMMON_ROUTES.payment.path,
				children: [...COMMON_ROUTES.payment.children],
			},
			...authRoutes,
			...categoryRoutes,
			...dashboardRoutes,
			...settingRoutes,
			...requestRoutes,
			...profileRoutes,
		],
	},
	{
		name: COMMON_ROUTES.requestExpired.name,
		path: COMMON_ROUTES.requestExpired.path,
		meta: COMMON_ROUTES.requestExpired.meta,
		props: COMMON_ROUTES.requestExpired.props,
		component: COMMON_ROUTES.requestExpired.component,
	},
	{
		name: COMMON_ROUTES.contactUs.name,
		path: COMMON_ROUTES.contactUs.path,
		meta: COMMON_ROUTES.contactUs.meta,
		component: COMMON_ROUTES.contactUs.component,
	},
	{
		name: COMMON_ROUTES.termsAndCondition.name,
		path: COMMON_ROUTES.termsAndCondition.path,
		meta: COMMON_ROUTES.termsAndCondition.meta,
		component: COMMON_ROUTES.termsAndCondition.component,
	},
	{
		name: COMMON_ROUTES.notFound.name,
		path: COMMON_ROUTES.notFound.path,
		meta: COMMON_ROUTES.notFound.meta,
		component: COMMON_ROUTES.notFound.component,
	},
]);

export default commonRoutes;
